// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Kaizen Dashboard components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// @mui material components
import TableRow from "@mui/material/TableRow";

// Kaizen Dashboard base styles
import { Icon, Tooltip } from "@mui/material";
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";
import SoftInputNumber from "components/SoftInputNumberUpgrade";
import { useEffect, useState } from "react";
import { getUproColor } from "utils/colors";
import { makeNiceText } from "utils/formatters";
import { formatMoneyPunto } from "utils/formatters";

function TableItem({ material, handleUpdateMaterial, handleRemoveMaterial, disabled }) {
  const { light } = colors;
  const { borderWidth } = borders;
  console.log(material);

  const [materialData, setMaterialData] = useState({
    ...material,
    cantidad: material?.cantidad || 0,
    precio: material?.precio || 0,
  });

  const handleChanges = (e) => {
    const { name, value } = e.target;
    setMaterialData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    handleUpdateMaterial(materialData);
  }, [materialData]);

  return (
    <TableRow hover>
      <SoftBox
        component="td"
        p={1}
        textAlign={"left"}
        borderBottom={`${borderWidth[1]} solid ${light.main}`}
      >
        <SoftBox
          display="flex"
          alignItems="center"
          sx={{
            cursor: "pointer",
          }}
        >
          <SoftBox pl={3} mr={2}>
            <Tooltip title={material.tipo} placement="top">
              <Icon
                sx={{
                  verticalAlign: "middle",
                  cursor: "pointer",
                  color:
                    material.tipo === "Material"
                      ? getUproColor("uproYellow")
                      : material.tipo === "Consumible"
                      ? getUproColor("uproGreen")
                      : getUproColor("uproPink"),
                }}
                fontSize="lg"
              >
                {material.tipo === "Material"
                  ? "category"
                  : material.tipo === "Consumible"
                  ? "recycling"
                  : "layers"}
              </Icon>
            </Tooltip>
          </SoftBox>
        </SoftBox>
      </SoftBox>
      <SoftBox
        component="td"
        p={1}
        textAlign={"left"}
        borderBottom={`${borderWidth[1]} solid ${light.main}`}
        sx={{
          verticalAlign: "bottom",
        }}
      >
        <SoftTypography
          verticalAlign={disabled ? "middle" : "text-top"}
          variant="caption"
          color="dark"
          fontWeight="bold"
        >
          {material?.id}
        </SoftTypography>
      </SoftBox>
      <SoftBox
        component="td"
        p={1}
        textAlign={"left"}
        borderBottom={`${borderWidth[1]} solid ${light.main}`}
        sx={{
          verticalAlign: "bottom",
        }}
      >
        <SoftTypography
          verticalAlign={disabled ? "middle" : "text-top"}
          variant="caption"
          color="secondary"
          fontWeight="medium"
        >
          {material?.nombre?.length > 70
            ? makeNiceText(material?.nombre).slice(0, 70) + "..."
            : makeNiceText(material?.nombre)}
          {material?.disabled && (
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="error"
              fontWeight="medium"
              sx={{ cursor: "pointer" }}
            >
              &nbsp; (Deshabilitado)
            </SoftTypography>
          )}
        </SoftTypography>
      </SoftBox>
      <SoftBox
        component="td"
        p={1}
        textAlign={"left"}
        borderBottom={`${borderWidth[1]} solid ${light.main}`}
        sx={{
          verticalAlign: "bottom",
        }}
      >
        <SoftTypography
          verticalAlign={disabled ? "middle" : "text-top"}
          variant="caption"
          color="secondary"
          fontWeight="medium"
        >
          {material?.categoria ? makeNiceText(material?.categoria) : "Sin rubro"}
        </SoftTypography>
      </SoftBox>

      <SoftBox
        component="td"
        p={1}
        textAlign={"center"}
        borderBottom={`${borderWidth[1]} solid ${light.main}`}
      >
        <SoftBox>
          {disabled ? (
            <SoftTypography
              verticalAlign="middle"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {`${materialData?.cantidad} ${material?.tipoUnidad?.abreviatura}`}
            </SoftTypography>
          ) : (
            <SoftInputNumber
              placeholder="Cantidad"
              name="cantidad"
              value={materialData?.cantidad}
              error={materialData?.cantidad < 0}
              onChange={handleChanges}
              icon={{
                component: (
                  <SoftBox
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <SoftTypography variant="h6">
                      {materialData?.tipoUnidad?.abreviatura}
                    </SoftTypography>
                  </SoftBox>
                ),
                direction: "right",
              }}
            />
          )}
        </SoftBox>
      </SoftBox>

      <SoftBox
        component="td"
        p={1}
        textAlign={"center"}
        borderBottom={`${borderWidth[1]} solid ${light.main}`}
      >
        <SoftBox>
          {disabled ? (
            <SoftTypography
              verticalAlign="middle"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {`$${formatMoneyPunto(material?.precio)}`}
            </SoftTypography>
          ) : (
            <SoftInputNumber
              placeholder="Precio"
              name="precio"
              value={materialData?.precio}
              error={materialData?.precio < 0}
              onChange={handleChanges}
              icon={{
                component: "attach_money",
                direction: "left",
              }}
            />
          )}
        </SoftBox>
      </SoftBox>

      {!disabled && (
        <SoftBox
          component="td"
          p={1}
          textAlign={"left"}
          borderBottom={`${borderWidth[1]} solid ${light.main}`}
        >
          <SoftBox
            display="flex"
            alignItems="center"
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftBox pl={3} mr={2}>
              <Tooltip title="Quitar de la lista" placement="top">
                <Icon
                  sx={{
                    verticalAlign: "middle",
                    cursor: "pointer",
                  }}
                  color="error"
                  fontSize="lg"
                  onClick={() => handleRemoveMaterial(material)}
                >
                  delete
                </Icon>
              </Tooltip>
            </SoftBox>
          </SoftBox>
        </SoftBox>
      )}
    </TableRow>
  );
}

// Typechecking props of the TableItem
TableItem.propTypes = {
  material: PropTypes.object.isRequired,
  handleUpdateMaterial: PropTypes.func.isRequired,
  handleRemoveMaterial: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default TableItem;
